import NotificationsSummary from './NotificationsSummary';

export default NotificationsSummary;
